import styled, { css } from 'styled-components';

const TabsContainer = styled.section`
  ${({ theme, withWhiteBackgroundColor }) =>
    css`
      display: flex;
      align-items: center;
      &&& {
        background-color: ${withWhiteBackgroundColor
          ? theme.colors.white
          : theme.colors.transparent};
        padding: ${withWhiteBackgroundColor
          ? theme.spacing(0, 0, 6, 8)
          : theme.spacing(6, 0, 6, 8)};
      }
    `}
`;

export default TabsContainer;
